import {Button, Col, Container, Row, Spinner, Modal, Form, Image, Alert, Card} from 'react-bootstrap';
import ReactStars from 'react-stars'
import SignatureCanvas from 'react-signature-canvas';
import { Document, Page } from 'react-pdf/dist/esm/entry.webpack';
import Webcam from "react-webcam";
import Navbar from "react-bootstrap/Navbar";
import logoImg from "../assets/netcomet.png";
import {useEffect, useState, useRef, useCallback} from "react";
import {api} from "../services/Api";
import CryptoJS from "crypto-js";
import {useAlert} from "../contexts/AlertContext";

interface ContractorProps {
	celular: string;
	email: string;
	nome: string;
}

interface ParametersProps {
	id_pessoa: string;
	id_pesquisa: string;
	id_contrato: string;
}


export function SignContract() {

	const url = window.location.href.split('assinar/');
	const token = url[1];

	const [parameters, setParameters] = useState<ParametersProps | null>(null);
	const [loading, setLoading] = useState<boolean>(true);
	const [authenticateLoading, setAuthenticateLoading] = useState<boolean>(false);
	const [disabled, setDisabled] = useState<boolean>(true);
	const [optionAuthenticateLoading, setOptionAuthenticateLoading] = useState<boolean>(false);
	const [error, setError] = useState<string>('');
	const [selfieError, setSelfieError] = useState<boolean>(false);
	const [authenticateMessage, setAuthenticateMessage] = useState<string>('');
	const [authenticateStatus, setAuthenticateStatus] = useState<string>('');
	const [modalAuthenticate, setModalAuthenticate] = useState<boolean>(false);
	const [optionAuthenticate, setOptionAuthenticate] = useState<string>('');
	const [contractor, setContractor] = useState<ContractorProps | null>(null);
	const [authenticationCode, setAuthenticationCode] = useState<number | null>(null);
	const [latitude, setLatitude] = useState<number | null>(null);
	const [longitude, setLongitude] = useState<number | null>(null);
	const [ip, setIp] = useState<number | null>(null);
	const [code, setCode] = useState<string>('');
	const [selfie, setSelfie] = useState<string>('');
	const [srcIframe, setSrcIframe] = useState<string | null>(null);
	const [numPages, setNumPages] = useState(0);
	const [pageNumber, setPageNumber] = useState(1);

	const [search, setSearch] = useState<boolean>(false);
	const [skipSearch, setSkipSearch] = useState<boolean>(false);
	const [searchAttendance, setSearchAttendance] = useState<number>(0);
	const [searchVelocity, setSearchVelocity] = useState<number>(0);
	const [searchStability, setSearchStability] = useState<number>(0);
	const [searchToHire, setSearchToHire] = useState<string>('');
	const [searchIndicate, setSearchIndicate] = useState<string>('');
	const [searchSuggestions, setSearchSuggestions] = useState<string>('');

	const sigCanvas = useRef<any>({});
	const webcamRef = useRef<any>(null);

	const capture = useCallback(
		() => {
			setSelfie(webcamRef.current.getScreenshot());
			setDisabled(false);
		},
		[webcamRef]
	);

	const { handleSetAlert } = useAlert();

	function onDocumentLoadSuccess(data: any) {
		setNumPages(data.numPages);
	}

	const renderPdf = useCallback( (lat: any, long: any) => {
		if (token) {
			const headers = {
				'Content-Type': 'application/json'
			};

			let data = {
				token: token,
			}

			api.post('v1/contratos/exibir-ip', data, { headers })
				.then((response) => {
					setIp(response.data.dados.ip);

					const headers = {
						'Content-Type': 'application/json'
					};

					let data = {
						token: token,
						ip: response.data.dados.ip,
						lat: lat,
						lng: long,
						agent: navigator.userAgent
					}

					api.post('v1/contratos/exibe-contrato-gerado', data, { headers })
						.then((response) => {
							const base64 = 'data:application/pdf;base64,'+response.data;

							const base64WithoutPrefix = base64.substr(`data:application/pdf;base64,`.length);

							const bytes = atob(base64WithoutPrefix);
							let length = bytes.length;
							let out = new Uint8Array(length);

							while (length--) {
								out[length] = bytes.charCodeAt(length);
							}

							let blob = new Blob([out], { type: 'application/pdf' });

							setSrcIframe(URL.createObjectURL(blob));
							setLoading(false);
						}).catch((error) => {
							setError(error.response.data.message);
							setLoading(false);
						});
				}).catch((error) => {
					setError(error.message);
					setLoading(false);
				});
		} else {
			setError('Não foi possível exibir o contrato. Para mais informações entre em contato com a nossa central de atendimento no telefone '+process.env.REACT_APP_SUPERGER_TELEFONE);
			setLoading(false);
		}
	},[token]);

	const getLocation = useCallback( () => {
		if ('geolocation' in navigator) {
			navigator.geolocation.getCurrentPosition(function (position: any) {
				setLatitude(position.coords.latitude)
				setLongitude(position.coords.longitude)
				renderPdf(position.coords.latitude, position.coords.longitude);
			}, function (erro) {
				renderPdf('', '');
			}, {
				enableHighAccuracy: true,
				maximumAge: 30000,
				timeout: 30000
			})
		} else {
			renderPdf('', '');
		}
	},[renderPdf]);

	useEffect(() => {
		let obj_json = JSON.parse(atob(token));
		let key = CryptoJS.PBKDF2(process.env.REACT_APP_SUPERGER_API_AUTHENTICATION_TOKEN_KEY as string, process.env.REACT_APP_SUPERGER_API_AUTHENTICATION_TOKEN_SALT as string, { hasher: CryptoJS.algo.SHA512, keySize: 64/8, iterations: 999});
		let decrypted = CryptoJS.AES.decrypt(obj_json.ciphertext, key, { iv: CryptoJS.enc.Hex.parse(process.env.REACT_APP_SUPERGER_API_AUTHENTICATION_TOKEN_IV_HEX as string)});
		let dataParameters = JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));

		setParameters(dataParameters);

		if (dataParameters.id_pesquisa) {
			setSearch(true);
		}

		getLocation();

	},[token, getLocation])

	async function handleToAccept() {
		if (token) {
			const headers = {
				'Content-Type': 'application/json',
			};

			let data = {
				token: token,
				ip: ip,
				lat: latitude,
				lng: longitude,
				agent: navigator.userAgent
			}

			api.post('v1/contratos/aceito', data, {headers})
				.then((response) => {
					setContractor(response.data.dados)
					setModalAuthenticate(true)
				}).catch((error) => {
					setError(error.response.data.message);
				});
		} else {
			setError('Não foi possível dar o aceito no contrato. Para mais informações entre em contato com a nossa central de atendimento no telefone '+process.env.REACT_APP_SUPERGER_TELEFONE);
		}
	}

	function handleSendAuthentication() {
		if (token) {
			if (!latitude || !longitude) {
				handleSetAlert({
					visible: true,
					variant: 'danger',
					message: 'Nós precisamos ter acesso a sua localização para exibir o contrato, por favor permita o acesso e recarregue a página',
					timeout: 5000
				});
			}

			const headers = {
				'Content-Type': 'application/json',
			};

			let tipo = '';
			let contato: string | undefined = '';
			if (optionAuthenticate === "email") {
				if (contractor?.email === '') {
					handleSetAlert({
						visible: true,
						variant: 'danger',
						message: 'Você não possui email cadastrado. Para mais informações entre em contato com a nossa central de atendimento no telefone: '+process.env.REACT_APP_SUPERGER_TELEFONE,
						timeout: 5000
					});
					return false;
				}else {
					tipo = optionAuthenticate;
					contato = contractor?.email;
				}
			} else if(optionAuthenticate === "sms") {
				if (contractor?.email === '') {
					handleSetAlert({
						visible: true,
						variant: 'danger',
						message: 'Você não possui celular cadastrado. Para mais informações entre em contato com a nossa central de atendimento no telefone: '+process.env.REACT_APP_SUPERGER_TELEFONE,
						timeout: 5000
					});
					return false;
				}else {
					tipo = optionAuthenticate;
					contato = contractor?.celular;
				}
			}

			setOptionAuthenticateLoading(true);

			let data = {
				token: token,
				ip: ip,
				tipo: tipo,
				contato: contato,
				lat: latitude,
				lng: longitude,
				agent: navigator.userAgent
			}

			api.post('v1/contratos/autenticar-assinatura', data, {headers})
				.then((response: any) => {
					setAuthenticationCode(response.data.dados.autenticacao);
					setOptionAuthenticateLoading(false);

					if (tipo === 'sms') {
						handleSetAlert({
							visible: true,
							variant: 'success',
							message: 'Código enviado por sms, por favor verifique o seu telefone para pegar o código',
							timeout: 5000
						});
					}
					if (tipo === 'email') {
						handleSetAlert({
							visible: true,
							variant: 'success',
							message: 'Código enviado por e-mail, por favor verifique o seu e-mail para pegar o código',
							timeout: 5000
						});
					}
				}).catch(() => {
					handleSetAlert({
						visible: true,
						variant: 'danger',
						message: 'Não foi possível enviar o código. Para mais informações entre em contato com a nossa central de atendimento no telefone '+process.env.REACT_APP_SUPERGER_TELEFONE,
						timeout: 5000
					});
				});
		}
	}

	function handleToSign(){
		if (token) {
			const headers = {
				'Content-Type': 'application/json',
			};

			let valueAuthenticate = '';
			if (optionAuthenticate === 'email' || optionAuthenticate === 'sms') {
				valueAuthenticate = code;
			} else if (optionAuthenticate === 'assinatura') {
				valueAuthenticate = sigCanvas.current.toDataURL().replace('data:image/png;base64,', '');
			} else if (optionAuthenticate === 'selfie') {
				valueAuthenticate = selfie.replace('data:image/png;base64,', '');
			}

			if (!valueAuthenticate) {
				handleSetAlert({
					visible: true,
					variant: 'warning',
					message: 'Você precisa informar a autenticação',
					timeout: 5000
				});
				return false;
			}

			setDisabled(true);
			setAuthenticateLoading(true);

			let data = {
				token: token,
				ip: ip,
				autenticacao: {
					tipo: optionAuthenticate,
					valor: valueAuthenticate
				},
				lat: latitude,
				lng: longitude,
				agent: navigator.userAgent
			}

		 api.post('v1/contratos/assinar', data, {headers})
			.then((response: any) => {
				if (response.status !== 200) {
					setAuthenticateMessage(response.data.message)
					setAuthenticateStatus('danger');
					setAuthenticateLoading(false);
				} else {
					if (parameters?.id_pesquisa && !skipSearch) {
						let dataSearch = {
							token: token,
							id_pessoa: parameters.id_pessoa,
							id_contrato: parameters.id_contrato,
							id_pesquisa: parameters.id_pesquisa,
							respostas: [
								{
									id_pergunta: 1,
									resposta: searchAttendance
								},
								{
									id_pergunta: 2,
									resposta: searchVelocity
								},
								{
									id_pergunta: 3,
									resposta: searchStability
								},
								{
									id_pergunta: 4,
									resposta: searchToHire
								},
								{
									id_pergunta: 5,
									resposta: searchIndicate
								},
								{
									id_pergunta: 6,
									resposta: searchSuggestions
								},
							]
						}

						api.post('v1/pesquisas/pesquisas-respostas/cadastrar', dataSearch, {headers})
							.then((response: any) => {
								setAuthenticateMessage(response.data.message)
								setAuthenticateStatus('success');
								setAuthenticateLoading(false);
							}).catch(() => {
								setAuthenticateMessage(response.data.message)
								setAuthenticateStatus('success');
								setAuthenticateLoading(false);
							})
					} else {
						setAuthenticateMessage(response.data.message)
						setAuthenticateStatus('success');
						setAuthenticateLoading(false);
					}
				}
			}).catch(() => {
			 	setAuthenticateMessage('Não foi possível assinar o contrato. Para mais informações entre em contato com a nossa central de atendimento no telefone '+process.env.REACT_APP_SUPERGER_TELEFONE);
				setAuthenticateStatus('danger');
				setAuthenticateLoading(false);
			})
		}
	}

	function handleSearch() {
		if (!searchAttendance) {
			handleSetAlert({
				visible: true,
				variant: 'warning',
				message: 'Informe a nota do atendimento na pesquisa',
				timeout: 5000
			});
			return false;
		}
		else if (!searchVelocity) {
			handleSetAlert({
				visible: true,
				variant: 'warning',
				message: 'Informe a nota da velocidade na pesquisa',
				timeout: 5000
			});
			return false;
		}
		else if (!searchStability) {
			handleSetAlert({
				visible: true,
				variant: 'warning',
				message: 'Informe a nota da estabilidade na pesquisa',
				timeout: 5000
			});
			return false;
		}
		else if (!searchToHire) {
			handleSetAlert({
				visible: true,
				variant: 'warning',
				message: 'Informe se voltaria a contratar na pesquisa',
				timeout: 5000
			});
			return false;
		}
		else if (!searchIndicate) {
			handleSetAlert({
				visible: true,
				variant: 'warning',
				message: 'Informe se indicaria a algum conhecido na pesquisa',
				timeout: 5000
			});
			return false;
		}

		setSearch(false);
	}

	return(
		<>
			<Navbar collapseOnSelect style={{height: 80}} className="header p1" expand="lg">
				<Container>
					<Navbar.Brand>
						<img src={logoImg} alt="Logo Netcomet"/>
					</Navbar.Brand>
					<Navbar.Brand className="d-flex m-0 color-dark-gray align-items-center">
						<span className="material-icons title-icon">menu_book</span>
						<p className="m-0">Contrato</p>
					</Navbar.Brand>
				</Container>
			</Navbar>
			<Container className="container-login p-3">
				{(loading || (!loading && error)) && <Row className="h-100">
					<Col md={12} className="align-self-center">
						{loading && <div className="justify-content-center align-items-center d-flex">
							<Spinner animation="border" role="status"/>
						</div>
						}
						{!loading && error && <div className="justify-content-center align-items-center d-flex">
							<Alert variant="danger">{error}</Alert>
						</div>}
					</Col>
				</Row>}
				<Row>
					<Col md={12}>
						<Row className="justify-content-center mb-3">
							{!loading && !error && search && <Container className="d-flex justify-content-center">
								<Col md={9}>
									<Card className="p-3">
										<Alert variant="primary" className="text-center fs-5 fw-bold">
											PESQUISA DE SATISFAÇÃO
										</Alert>
										<Col md={12} className="d-flex w-100 mb-4 justify-content-center">
											<Col md={12} className="row ml-0 w-100 fs-5">
												<Col md={8} className="align-self-center">
													<label className="fw-bold">Grau de satisfação com o atendimento: </label>
												</Col>
												<Col md={4}>
													<ReactStars count={5} className="d-flex justify-content-between" half={false} onChange={(value) => {setSearchAttendance(value);}} value={searchAttendance} size={30} color2={'#ffd700'} />
												</Col>
											</Col>
										</Col>
										<Col md={12} className="d-flex w-100 mb-4 justify-content-center">
											<Col md={12} className="row ml-0 w-100 fs-5">
												<Col md={8} className="align-self-center">
													<label className="fw-bold">Grau de satisfação com a velocidade: </label>
												</Col>
												<Col md={4}>
													<ReactStars count={5} className="d-flex justify-content-between" half={false} onChange={(value) => {setSearchVelocity(value);}} value={searchVelocity} size={30} color2={'#ffd700'} />
												</Col>
											</Col>
										</Col>
										<Col md={12} className="d-flex w-100 mb-4 justify-content-center">
											<Col md={12} className="row ml-0 w-100 fs-5">
												<Col md={8} className="align-self-center">
													<label className="fw-bold">Grau de satisfação com a estabilidade: </label>
												</Col>
												<Col md={4}>
													<ReactStars count={5} className="d-flex justify-content-between" half={false} onChange={(value) => {setSearchStability(value);}} value={searchStability} size={30} color2={'#ffd700'} />
												</Col>
											</Col>
										</Col>
										<Col md={12} className="d-flex w-100 mb-4 justify-content-center">
											<Col md={12} className="row ml-0 w-100 fs-5">
												<Col md={8}>
													<label className="fw-bold">Voltaria a contratar: </label>
												</Col>
												<Col md={4} className="d-flex">
													<Col md={6} className="custom-control custom-radio align-items-center d-flex me-3">
														<input type="radio" id="voltaria-contratar-1" name="voltaria-contratar" onClick={() => {setSearchToHire('Sim');}} className="form-check-input mt-0"/>
															<label className="custom-control-label font-weight-normal ms-2" htmlFor="voltaria-contratar-1">Sim</label>
													</Col>
													<Col md={6} className="custom-control custom-radio align-items-center d-flex">
														<input type="radio" id="voltaria-contratar-2" name="voltaria-contratar" onClick={() => {setSearchToHire('Não');}} className="form-check-input mt-0"/>
															<label className="custom-control-label font-weight-normal ms-2" htmlFor="voltaria-contratar-2">Não</label>
													</Col>
												</Col>
											</Col>
										</Col>
										<Col md={12} className="d-flex w-100 mb-4 justify-content-center">
											<Col md={12} className="row ml-0 w-100 fs-5">
												<Col md={8} sm={12}>
													<label className="fw-bold">Indicaria a algum conhecido: </label>
												</Col>
												<Col md={4} sm={12} className="d-flex">
													<Col md={6} className="custom-control custom-radio align-items-center d-flex me-3">
														<input type="radio" id="indicaria-1" name="indicaria" onClick={() => {setSearchIndicate('Sim');}} className="form-check-input mt-0"/>
															<label className="custom-control-label font-weight-normal ms-2" htmlFor="indicaria-1">Sim</label>
													</Col>
													<Col md={6} className="custom-control custom-radio align-items-center d-flex">
														<input type="radio" id="indicaria-2" name="indicaria" onClick={() => {setSearchIndicate('Não');}} className="form-check-input mt-0"/>
															<label className="custom-control-label font-weight-normal ms-2" htmlFor="indicaria-2">Não</label>
													</Col>
												</Col>
											</Col>
										</Col>
										<Col md={12} className="d-flex w-100 mb-4 justify-content-center">
											<Col md={12} className="row ml-0 w-100 fs-5">
												<Col md={12}>
													<label className="fw-bold">Sugestões e/ou reclamações (Opcional): </label>
												</Col>
												<Col md={12} className="mt-4">
													<Col md={12} className="form-group shadow-textarea w-100">
														<textarea
															className="form-control z-depth-1"
															onChange={(value) => {setSearchSuggestions(value.target.value)}}
															maxLength={300}
															rows={3}
															placeholder="Escreva seu comentário aqui..."
														>
														</textarea>
													</Col>
												</Col>
											</Col>
										</Col>
										<Col md={12} className="d-flex w-100 mb-4">
											<Button variant={"success"} onClick={() => {handleSearch()}} className="w-100">Enviar e assinar o cancelamento</Button>
										</Col>
										<Col md={3} className="d-flex align-self-end">
											<Button variant={"light"} onClick={() => {setSearch(false); setSkipSearch(true);}} className="w-100">Pular Pesquisa</Button>
										</Col>
									</Card>
								</Col>
							</Container>}
							{!loading && !error && !search && <>
								{srcIframe && <>
									{numPages > 0 && <>
										<Col sm={12} className="mb-2">
											{numPages > 1  && <Button variant="light" disabled={pageNumber <= 1} onClick={() => setPageNumber(pageNumber-1)}>Página Anterior</Button>}
											{numPages > 1 && <Button variant="light" className="float-end" disabled={pageNumber === numPages} onClick={() => setPageNumber(pageNumber+1)}>Próxima Página</Button>}
										</Col>
									</>}
									<Document renderMode={"svg"} file={srcIframe} className="w-100 h-100" loading={<div className="justify-content-center align-items-center d-flex p-2"><Spinner animation="border" role="status"/></div>} onLoadSuccess={onDocumentLoadSuccess}>
										<Page className="w-100 h-100" pageNumber={pageNumber} />
									</Document>
									{numPages > 0 && <>
										<Col sm={12} className="m-3">
											<Button id="btn_accept" className="d-flex w-100 justify-content-center" variant="success" onClick={() => {handleToAccept()}}>
												Eu li e aceito os termos acima
											</Button>
										</Col>
									</>}
								</>}
							</>}
						</Row>
					</Col>
				</Row>
			</Container>

			<Modal size="lg" aria-labelledby="contained-modal-title-vcenter" centered show={modalAuthenticate} onHide={() => {}}>
				{!authenticateLoading && !authenticateMessage && <Modal.Header className="border-0">
					<Modal.Title className="fs-5">Escolha como você quer autenticar a assinatura do contrato</Modal.Title>
				</Modal.Header>}
				<Modal.Body className="d-grid">
					{authenticateLoading && <div className="justify-content-center align-items-center text-center mt-3">
						<Spinner animation="border" role="status"/>
						<p className="mt-4">Executando operação, aguarde um momento</p>
					</div>}
					{!authenticateLoading && authenticateMessage && authenticateStatus === 'success' && <>
						<Alert variant="success" className="text-center">
							Seu contrato está assinado e pronto! <br/>
							Obrigado por confiar em nossa conexão! Para ficarmos ainda mais conectados, adicione nosso WhatsApp 08007350600
						</Alert>
						<Col md={12}>
							<p className="text-center">
								<a href="https://api.whatsapp.com/send?phone=558007350600" className="btn btn-success">
									Adicionar WhatsApp
								</a>
							</p>
						</Col>
					</>}
					{!authenticateLoading && authenticateMessage && authenticateStatus === 'danger' && <>
						<Alert variant="danger" className="text-center">
							{authenticateMessage}
						</Alert>
						</>}
					{!authenticateLoading && !authenticateMessage && <>
						<select
							className="form-control"
							placeholder="Selecione a autenticação"
							onChange={(value) => {
								if (value.target.value === 'selfie') {
									navigator.mediaDevices.getUserMedia({audio: false, video: true})
										.then(() => {
										}).catch(() => {
											setSelfieError(true);
										});
								}
								setOptionAuthenticate(value.target.value);
								setSelfie('');
								setCode('');
								setAuthenticationCode(null);
								setDisabled(true);
							}}
						>
							<option disabled selected value="null">Selecione a autenticação</option>
							<option value="email">E-mail</option>
							<option value="sms">SMS</option>
							<option value="assinatura">Assinatura</option>
							<option value="selfie">Selfie(Foto)</option>
						</select>
						{optionAuthenticate === "email" && contractor?.email && <>
							<label className="mt-3">Vamos enviar o código para o e-mail: <b>{contractor?.email}</b></label>
						</>}
						{optionAuthenticate === "email" && !contractor?.email && <>
							<Alert variant="danger" className="mt-3 text-center">E-mail não encontrado, tente outra opção</Alert>
						</>}
						{optionAuthenticate === "sms" && contractor?.celular &&<>
							<label className="mt-3">Vamos enviar o código para o telefone:  <b>{contractor?.celular}</b></label>
						</>}
						{optionAuthenticate === "sms" && !contractor?.celular && <>
							<Alert variant="danger" className="mt-3 text-center">Telefone não encontrado, tente outra opção</Alert>
						</>}
						{!optionAuthenticateLoading && authenticationCode && (optionAuthenticate === "email" || optionAuthenticate === "sms") && <>
							<label className="mt-3">Informe o código que você recebeu</label>
							<Form.Control
								onChange={(value) => {
									setCode(value.target.value);
									setDisabled(false);
								}}
								className="mt-3"
								placeholder="Digite aqui o código recebido"
							/>
						</>}
						{(optionAuthenticate === "email" && contractor?.email) && <>
							<Button variant={"success"} className="mt-3" onClick={() => {handleSendAuthentication()}}>{!authenticationCode ? 'Enviar Código' : 'Reenviar Código'}</Button>
						</>}
						{(optionAuthenticate === "sms" && contractor?.celular) && <>
							<Button variant={"success"} className="mt-3" onClick={() => {handleSendAuthentication()}}>{!authenticationCode ? 'Enviar Código' : 'Reenviar Código'}</Button>
						</>}
						{optionAuthenticate === "assinatura" && <>
							<Button variant={"danger"} className="mt-3" onClick={() => {sigCanvas.current.clear(); setDisabled(true)}}>Limpar</Button>
							<div className="div-signature mt-3">
								<SignatureCanvas
									onEnd={() => {setDisabled(false)}}
									ref={sigCanvas}
									penColor='black'
									canvasProps={{className: 'signature-canvas'}}
								/>
							</div>
						</>}
						{optionAuthenticate === "selfie" && <>
							{selfieError && <Alert variant="danger" className="mt-3 text-center">Não foi possível acessar a sua câmera, tente outro tipo de autenticação, ou altere a permissão e recarregue a página</Alert>}
							{!selfieError && !selfie && <Button variant={"success"} className="mt-3" onClick={() => {capture()}}>Tirar Selfie</Button>}
							{!selfieError && selfie && <Button variant={"success"} className="mt-3" onClick={() => {setSelfie(''); setDisabled(true)}}>Nova Selfie</Button>}
							<div className="d-flex justify-content-center mt-3">
								{!selfieError && !selfie && <Webcam
									className="selfie"
									audio={false}
									ref={webcamRef}
									screenshotFormat="image/png"
									videoConstraints={{facingMode: "user"}}
									width={300}
								/>}
								{selfie && <Image src={selfie}/>}
							</div>
						</>}
						{optionAuthenticateLoading && <div className="justify-content-center align-items-center d-flex mt-3">
							<Spinner animation="border" role="status"/>
						</div>}
					</>}
				</Modal.Body>
				{!authenticateLoading && authenticateStatus !== 'success' && <Modal.Footer className="border-0">
					{!authenticateMessage && <>
						<Button variant="success" disabled={disabled} onClick={() => {handleToSign()}}>
							Assinar
						</Button>
						<Button
							variant="light"
							onClick={() => {!authenticateLoading && authenticateMessage ? window.location.reload() : setModalAuthenticate(false); setOptionAuthenticate(''); }}
						>
							Fechar
						</Button>
					</>}
				</Modal.Footer>}
			</Modal>
		</>
	);
}
